import { render, staticRenderFns } from "./FormFileList.vue?vue&type=template&id=23792870&scoped=true"
import script from "./FormFileList.vue?vue&type=script&lang=js"
export * from "./FormFileList.vue?vue&type=script&lang=js"
import style0 from "./FormFileList.vue?vue&type=style&index=0&id=23792870&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23792870",
  null
  
)

export default component.exports